export default function getScript(d, src, { async = true, defer = true } = {}) {
  return new Promise((resolve, reject) => {
    const existing = Array.from(d.querySelectorAll(`script`)).find((s) => s.src === src);
    if (existing) return resolve();

    const el = d.createElement(`script`);
    el.src = src;
    el.async = async;
    el.defer = defer;
    el.onload = () => resolve();
    el.onerror = (e) =>
      reject(new Error(`addScript failed: ${JSON.stringify(e, ['message', 'arguments', 'type', 'name'])}`)); //To be able to see the error

    d.body.appendChild(el);
  });
}
